import { ErrorHandler, Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Session_ErrorHandlerWebApi } from "../Service/WebApi/Session_ErrorHandlerWebApi";
import { Session_ErrorHandlerModel } from "../Models/Model/Session_ErrorHandlerModel";

//Log errors
@Injectable({ providedIn: 'root' })
export class Session_ErrorHandler extends ErrorHandler {
  constructor(public http: HttpClient) {
    super();
  }

  handleError(error: Error) {
    var sessionErrorHandle = new Session_ErrorHandlerWebApi(this.http);
    let sessionErrorHandleModel = new Session_ErrorHandlerModel();
    sessionErrorHandleModel.message = error.message;
    sessionErrorHandleModel.name = error.name;
    sessionErrorHandleModel.stack = error.stack;

    if (error.message.indexOf("new DOMParser") > -1) {
      return;
    }
    if (error.stack) {
      if (error.stack.indexOf("new DOMParser") > -1) {
        return;
      }   
      if (error.stack.indexOf("postMessage") > -1) {
        return;
      }
    }
    sessionErrorHandle.logError(sessionErrorHandleModel).subscribe((data) => { }, (error) => { });
  }
}
